import { Col, Row } from "antd";
import React, { JSX, ReactNode } from "react";

export interface OrderFormRowProps {
  children: ReactNode | ReactNode[];
  isAlwaysDouble?: boolean;
  className?: string;
}

const OrderFormRow = (props: OrderFormRowProps): JSX.Element => {
  const { children, isAlwaysDouble } = props;
  const length = Array.isArray(children) ? children.length : 1;
  if (length === 1 && isAlwaysDouble !== true) {
    return (
      <div className={`order-form-row-1 ${props.className}`}>
        {children}
      </div>
    );
  }
  const items = [];
  for (let i = 0; i < length; i += 2) {
    const leftChild = (children as any)[i];
    const rightChild = i + 1 < length ? (children as any)[i + 1] : undefined;
    items.push(
      <Row key={`order-form-row-${i}`} gutter={12} className={`${props.className}`}>
        <Col span={24} xl={12}>{leftChild}</Col>
        {rightChild && <Col span={24} xl={12}>{rightChild}</Col>}
      </Row>
    );
  }
  return items as any;
}

export default OrderFormRow;
